<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import AppSidebar from '@/components/sidebar/AppSidebar.vue';
import { SidebarProvider } from '@/components/ui/sidebar';
import { useIsMobile } from '@/composables/useIsMobile';

const route = useRoute();
const isMobile = useIsMobile();
const isSidebarOpen = ref<boolean>(!isMobile.value);

watch(isMobile, (mobile) => {
    isSidebarOpen.value = !mobile;
});

// On mobile the sidebar overlaps the content, so any navigation closes it.
watch(
    () => route.fullPath,
    () => {
        if (isMobile.value) isSidebarOpen.value = false;
    }
);
</script>
<template>
    <SidebarProvider
        :open="isSidebarOpen"
        @update:open="isSidebarOpen = $event"
        class="flex text-foreground gap-1 h-full"
    >
        <Transition
            enter-active-class="transition-opacity duration-200"
            leave-active-class="transition-opacity duration-200"
            enter-from-class="opacity-0"
            leave-to-class="opacity-0"
        >
            <button
                v-if="isMobile && isSidebarOpen"
                type="button"
                class="fixed inset-0 z-30 bg-black/50"
                @click="isSidebarOpen = false"
            >
                <span class="sr-only">Close menu</span>
            </button>
        </Transition>
        <AppSidebar :is-sidebar-open="isSidebarOpen" />
        <main
            class="main_container relative flex-1 bg-background overflow-hidden rounded-sm"
        >
            <slot />
        </main>
    </SidebarProvider>
</template>
